import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

/**
 * Component for a check box
 */
@Component({
    selector: 'app-check-box',
    templateUrl: './check-box.component.html',
    styleUrls: ['./check-box.component.scss'],
    standalone: false
})
export class CheckBoxComponent {

  @Input() nameInput: string;
  @Input() control: UntypedFormControl;
  @Input() value: boolean;
  @Input() disabled: boolean;
  @Input() checkBoxOffset = 'mr-2 ml-1';
  @Input() labelClasses = 'text-primary font-weight-bold';
  @Input() showTooltip: boolean;

  @Output() valueChange = new EventEmitter();

  public onLabelClick(): void {
    if (this.disabled) {
      return;
    }
    if (this.control) {
      this.control.patchValue(!this.control.value)
    }
    if (!this.control) {
      this.value = !this.value;
      this.valueChange.emit(this.value);
    }
  }

}
